import { render } from "./ProxyManagement.vue?vue&type=template&id=9b2d56be"
import script from "./ProxyManagement.vue?vue&type=script&lang=js"
export * from "./ProxyManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__